import { JURISDICTIONS, TIMELINES } from "@/app/calculator/constants/calculatorData";
import { StepLabel, CheckIcon } from "./Ui";

export function StepLocation({ data, onChange }) {
  return (
    <div className="space-y-6">

      {/* Header */}
      <StepLabel
        tag="Location"
        title="Location & Timeline"
        description="These details shape your proposal jurisdiction, residency, and when you'd like to start."
      />

      {/* Jurisdiction */}
      <div className="space-y-2">
        <p className="text-sm sm:text-base font-semibold text-gray-700">
          Preferred Jurisdiction
        </p>

        <div className="space-y-2">
          {JURISDICTIONS.map((j) => (
            <button
              key={j.id}
              onClick={() => onChange("jurisdiction", j.id)}
              className={`w-full flex items-start gap-3 px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl border text-left transition-all ${
                data.jurisdiction === j.id
                  ? "border-[#B8893A] bg-[#B8893A]/10 ring-1 ring-[#B8893A]/30"
                  : "border-gray-200 hover:border-[#B8893A]/40 hover:bg-gray-50"
              }`}
            >
              <span className="flex-1">
                <span className="block text-sm sm:text-base font-semibold text-gray-800">
                  {j.label}
                </span>
                <span className="block text-xs text-gray-400 mt-0.5">
                  {j.sub}
                </span>
              </span>

              {data.jurisdiction === j.id && (
                <CheckIcon />
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Living in UAE */}
      <div className="space-y-2">
        <p className="text-sm sm:text-base font-semibold text-gray-700">
          Are you currently living in the UAE?
        </p>

        <div className="flex gap-2 sm:gap-3">
          {["Yes", "No"].map((v) => (
            <button
              key={v}
              onClick={() => onChange("inUAE", v)}
              className={`flex-1 py-2 sm:py-2.5 rounded-xl border text-xs sm:text-sm font-semibold transition-all ${
                data.inUAE === v
                  ? "border-[#B8893A] bg-[#B8893A]/10 text-[#B8893A] ring-1 ring-[#B8893A]/30"
                  : "border-gray-200 text-gray-600 hover:border-[#B8893A]/40"
              }`}
            >
              {v}
            </button>
          ))}
        </div>
      </div>

      {/* Timeline */}
      <div className="space-y-2">
        <p className="text-sm sm:text-base font-semibold text-gray-700">
          When do you plan to start?
        </p>

        <div className="grid grid-cols-2 gap-2">
          {TIMELINES.map((t) => (
            <button
              key={t}
              onClick={() => onChange("timeline", t)}
              className={`py-2 sm:py-2.5 rounded-xl border text-xs sm:text-sm font-semibold transition-all ${
                data.timeline === t
                  ? "border-[#B8893A] bg-[#B8893A]/10 text-[#B8893A] ring-1 ring-[#B8893A]/30"
                  : "border-gray-200 text-gray-600 hover:border-[#B8893A]/40"
              }`}
            >
              {t}
            </button>
          ))}
        </div>
      </div>

    </div>
  );
}
